import { cn } from "@/lib/utils";
import type {
  ElementType,
  ForwardedRef,
  HTMLAttributes,
  ReactNode,
} from "react";
import { Children, forwardRef } from "react";

export interface CarouselProps extends HTMLAttributes<HTMLDivElement> {
  hideNavigation?: boolean;
  classNames?: {
    wrapper?: string;
    slider?: string;
    item?: string;
  };
  PreviousButton?: () => ReactNode;
  NextButton?: () => ReactNode;
  Pagination?: ElementType;
}

export const Carousel = forwardRef(
  (
    {
      children,
      hideNavigation = false,
      classNames,
      PreviousButton,
      NextButton,
      Pagination,
    }: CarouselProps,
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    const numberOfItems = Children.count(children);

    return (
      <div
        className={cn(
          "relative [--gap:1rem] [--slides-per-view:1]",
          classNames?.wrapper,
        )}
      >
        {PreviousButton &&
          !hideNavigation &&
          numberOfItems > 1 &&
          PreviousButton()}

        <div
          className={cn(
            `flex w-full snap-x snap-mandatory gap-[var(--gap)] overflow-x-scroll`,
            classNames?.slider,
          )}
          ref={ref}
        >
          {/* Set basis to slides per view minus gap. */}
          {Children.map(children, (child, index) => (
            <div
              className={cn(
                "min-w-0 shrink-0 basis-[calc((100%_-_((var(--slides-per-view)_-_1)_*_var(--gap)))_/_var(--slides-per-view))] snap-start",
                classNames?.item,
              )}
              data-index={index}
            >
              {child}
            </div>
          ))}
        </div>

        {NextButton && !hideNavigation && numberOfItems > 1 && NextButton()}
        {Pagination && <Pagination sliderRef={ref} />}
      </div>
    );
  },
);
